import { render, staticRenderFns } from "./CommonSendCode.vue?vue&type=template&id=60d4cb60&scoped=true&"
import script from "./CommonSendCode.vue?vue&type=script&lang=js&"
export * from "./CommonSendCode.vue?vue&type=script&lang=js&"
import style0 from "./CommonSendCode.vue?vue&type=style&index=0&id=60d4cb60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d4cb60",
  null
  
)

export default component.exports